<template>
  <page id="quiz">
    <div class="m-grid__item m-grid__item--fluid m-wrapper" v-if="forbidden">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="align-items-center break-word">
          <div class="mr-auto">
            <h1 class="m-subheader__title full-max-width" v-encode="forbidden.title"></h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content break-word m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body overflow-x-auto" v-html="forbidden.content"></div>
        </div>
      </div>
    </div>

    <div class="m-grid__item m-grid__item--fluid m-wrapper" v-else-if="!quiz">
      <div class="m-content text-left" >
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                Brak danych
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-grid__item m-grid__item--fluid m-wrapper" v-else-if="quiz">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader d-flex">
        <div class="align-items-center break-word">
          <div class="mr-auto">
            <div v-if="showReturn" class="mr-3 d-inline">
              <button class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls"
                      @click="pushToReturn">Wróć
              </button>
            </div>
            <h1 class="m-subheader__title full-max-width" v-encode="quiz.name"></h1>
            <div v-if="!quiz.result" class="subtitle mt-1">
              <span v-if="quiz.type === SURVEY_QUIZ">Aktywny</span>
              <span v-else>Aktywna</span>
              <span v-if="quiz.points > 0">
                | Do zdobycia <span class="font-ls">{{ quiz.points }} {{pointsSymbol}}</span>
              </span>
            </div>
            <div v-else class="subtitle">
              <span v-if="quiz.type === SURVEY_QUIZ">Rozwiązany</span> <span v-else>Wypełniona</span> <span> w dniu {{ quiz.result.date_solved | moment('DD.MM.YYYY') }}
              godz. {{ quiz.result.date_solved | moment('HH:mm') }}</span>
              <span v-if="quiz.result.points > 0">| Otrzymano <span class="font-ls">{{ quiz.result.points }} {{pointsSymbol}}</span></span>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content break-word m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div v-if="quiz.description || quiz.short_description || quiz.picture"
               class="m-portlet__body overflow-x-auto">
            <div class="row">
              <div v-if="quiz.picture" class="col-12 col-lg text-center">
                <img :src="quiz.picture.picture" class="img-fluid" alt="">
              </div>
              <div class="col-12 col-lg mt-4 mt-lg-0" v-html="quiz.short_description"></div>
            </div>
            <div v-if="quiz.description" class="row mt-4">
              <div class="col" v-html="quiz.description"></div>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__foot--fit">
            <div v-for="question in quiz.questions" :key="question.id" class="row mt-5 pl-5 pr-5">
              <div class="col-12">
                <div v-if="question.picture" class="text-center mb-4">
                  <img :src="question.picture" class="img-fluid" alt="">
                </div>
                <h3 :class="[isInvalid(question.id) && 'has-error']">{{ question.question }}</h3>
                <div v-if="question.description" v-html="question.description"></div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div v-if="question.type === POLL_QUESTION_TYPE_QUIZ"
                       v-for="answer in question.answers" :key="answer.id" class="col-12 col-lg-7 mt-3">
                    <b-form-checkbox
                        :value="answer.id"
                        v-model="answers[question.id]"
                        :unchecked-value="false"
                        :disabled="!!quiz.result"
                        @change="validateQuizQuestion(question.id)"
                        size="lg">
                      <span :class="resolveClassForAnswer(question.id, answer)">{{ resolveTextForAnswer(question.id, answer) }}</span>
                    </b-form-checkbox>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_TEXT" class="col-12 col-lg-7 mt-3">
                    <b-form-input type="text" v-model="answers[question.id]" :disabled="!!quiz.result"
                                  maxlength="300"
                                  @blur="validateFields(question.id)"/>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_TEXTAREA" class="col-12 col-lg-7 mt-3">
                    <b-form-textarea v-model="answers[question.id]" :disabled="!!quiz.result"
                                     maxlength="5000"
                                     rows="3"
                                     @blur="validateFields(question.id)"/>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_TAGS" class="col-12 col-lg-7 mt-3">
                    <tags-input :field-key="question.id"
                                v-model="answers[question.id]"
                                maxlength="120"
                                @initialized="initializeTags()"
                                @tags-updated="validateFields(question.id)"
                                @blur="validateFields(question.id)"
                                :disabled="!!quiz.result"></tags-input>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_SWITCH" class="col-12 col-lg-7 mt-3 d-flex align-items-center ml-1">
                    <switches :disabled="!!quiz.result"
                              class="form-switch mt-3"
                              :color="answers[question.id] ? 'green' : 'default'"
                              v-model="answers[question.id]"></switches>
                    <label class="form-label m-0 mt-1 ml-4 p-0">
                      {{ answers[question.id] ? 'Tak' : 'Nie' }}
                    </label>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_NUMBER" class="col-12 col-lg-7 mt-3">
                    <number-spinner :disabled="!!quiz.result"
                                    :ref="`q-${question.id}`"
                                    @invalid="pushInvalidField(question.id)"
                                    @valid="removeInvalidField(question.id)"
                                    v-model.number="answers[question.id]"/>
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_SELECT" class="col-12 col-lg-7 mt-3">
                    <radio-select-input :field-key="question.id"
                                        :disabled="!!quiz.result"
                                        v-model="answers[question.id]"
                                        :options="question.answers"
                                        value-key="id"
                                        :inline="false"
                                        @click="validateFields(question.id)"
                                        text-key="answer"
                    />
                  </div>
                  <div v-if="question.type === POLL_QUESTION_TYPE_MULTISELECT" class="col-12 col-lg-7 mt-3">
                    <multi-select-input :ref="`q-${question.id}`"
                                        :disabled="!!quiz.result"
                                        :field-key="question.id"
                                        v-model="answers[question.id]"
                                        :options="question.answers"
                                        :limits="getLimits(question)"
                                        value-key="id"
                                        invalid-on-empty
                                        :inline="false"
                                        @invalid="pushInvalidField(question.id)"
                                        @valid="removeInvalidField(question.id)"
                                        text-key="answer"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-5 text-center">
              <button v-if="!quiz.result" class="btn btn-lg btn-ls" @click="solve">
                {{ quiz.type ? 'Wypełnij' : 'Rozwiąż' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="isSolvedModalOpen" lazy hide-footer hide-header centered size="lg">
      <img src="@/assets/app/media/img/icons/close.png" @click="isSolvedModalOpen = false" class="close" alt="X">
      <div v-html="message"></div>
    </b-modal>
  </page>
</template>

<script>
import Page from "./Page";
import Encode from "@/directives/encode";
import debounce from 'lodash.debounce'
import {mapActions, mapState} from "vuex";
import Spinner from "../spinner/Spinner";
import {fail, finish, start} from "@/utils/Progress";
import {entityUuidFromLocation} from "@/utils/EntityUuid";
import http from "@/axios";
import store from "@/store";
import Switches from "vue-switches";
import NumberSpinner from "@/components/input/NumberSpinner";
import RadioSelectInput from "@/components/input/RadioSelectInput";
import MultiSelectInput from "@/components/input/MultiSelectInput";
import TagsInput from "@/components/input/TagsInput";
import {
  POLL_QUESTION_TYPE_MULTISELECT,
  POLL_QUESTION_TYPE_NUMBER,
  POLL_QUESTION_TYPE_QUIZ,
  POLL_QUESTION_TYPE_SELECT,
  POLL_QUESTION_TYPE_SWITCH,
  POLL_QUESTION_TYPE_TAGS,
  POLL_QUESTION_TYPE_TEXT,
  POLL_QUESTION_TYPE_TEXTAREA
} from "@/utils/PollFieldsTypes";
import {SURVEY_POLL, SURVEY_QUIZ} from "@/utils/SurveyTypes";

export default {
  name: "QuizPage",
  components: {MultiSelectInput, RadioSelectInput, NumberSpinner, Spinner, Page, TagsInput, Switches,},
  directives: {Encode},
  data() {
    return {
      SURVEY_QUIZ: SURVEY_QUIZ,
      SURVEY_POLL: SURVEY_POLL,
      POLL_QUESTION_TYPE_QUIZ: POLL_QUESTION_TYPE_QUIZ,
      POLL_QUESTION_TYPE_TEXT: POLL_QUESTION_TYPE_TEXT,
      POLL_QUESTION_TYPE_TEXTAREA: POLL_QUESTION_TYPE_TEXTAREA,
      POLL_QUESTION_TYPE_TAGS: POLL_QUESTION_TYPE_TAGS,
      POLL_QUESTION_TYPE_SWITCH: POLL_QUESTION_TYPE_SWITCH,
      POLL_QUESTION_TYPE_NUMBER: POLL_QUESTION_TYPE_NUMBER,
      POLL_QUESTION_TYPE_SELECT: POLL_QUESTION_TYPE_SELECT,
      POLL_QUESTION_TYPE_MULTISELECT: POLL_QUESTION_TYPE_MULTISELECT,
      forbidden: null,
      isSolvedModalOpen: false,
      quiz: false,
      answers: {},
      message: '',
      answersCount: 0,
      invalidFields: [],
      replaceAnswers: true,
    }
  },
  beforeRouteEnter(to, from, next) {
    start();

    const storageKey = 'ls-member-module-' + entityUuidFromLocation();
    const state = JSON.parse(localStorage.getItem(storageKey));

    if (!state) {
      fail();
      return;
    }

    http.get(`quizzes/${to.params.id}`, {
      headers: {
        Authorization: `Bearer ${state.auth.token}`
      }
    })
        .then((r) => {
          next(vm => {
            vm.setQuiz(r.data.quiz)
          })
          finish();
        })
        .catch((e) => {
          fail();

          if (e.response.status === 403) {
            next(vm => {
              vm.setForbidden(to)
            });

            return;
          }

          next(vm => {
            vm.quiz = false;
            vm.answers = {};
          });
        })
  },
  beforeRouteUpdate(to, from, next) {
    start();

    http.get(`quizzes/${to.params.id}`)
        .then((r) => {
          this.setQuiz(r.data.quiz);
          next();
        })
        .then(() => finish())
        .catch((e) => {
          fail();
          if (e.response.status === 403) {
            this.setForbidden(to)
          } else if(e.response.status === 404){
            this.quiz = false;
            this.answers = {};
          }else {
            this.pushToFirstAvailablePage();
          }
          next();
        })
  },
  methods: {
    ...mapActions([
      'fetchUser',
      'pushToFirstAvailablePage',
    ]),
    fetchQuiz(id) {
      if (!id) {
        id = this.$route.params.id
      }

      return this.$http.get(`quizzes/${id}`)
          .then(r => this.setQuiz(r.data.quiz))
    },
    setQuiz(quiz) {
      this.quiz = quiz;
      const matchingRoute = store.getters.getMatchingRoute(this.$route);

      if (this.quiz.type === SURVEY_QUIZ && this.$route.name.startsWith('Poll')
          || this.quiz.type === SURVEY_POLL && this.$route.name.startsWith('Quiz')
      ) {
        this.$set(this, 'forbidden', {
          title: matchingRoute ? matchingRoute.title : '',
          content: 'Brak dostępu.'
        });

        return;
      }


      this.$set(this, 'forbidden', null);

      if (this.replaceAnswers && this.quiz.result) {
        this.$set(this, 'answers', this.quiz.result.answers);
      }
    },
    initializeTags() {
      Object.entries(this.quiz.questions).forEach(([, question]) => {
        if (question.type === POLL_QUESTION_TYPE_TAGS && this.answers.hasOwnProperty(question.id)) {
          this.answers[question.id] = this.answers[question.id].map((a) => ({key: a, value: a}))
        }
      })
    },
    setForbidden(to) {
      const matchingRoute = store.getters.getMatchingRoute(to);

      this.$set(this, 'forbidden', {
        title: matchingRoute ? matchingRoute.title : '',
        content: 'Brak dostępu.'
      });
    },
    solve: debounce(function () {
      setTimeout(() => this.validateRefs(), 0);
      setTimeout(() => this.validateFields(), 0);

      setTimeout(() => {
        if (this.invalidFields.length) {
          this.$notify.warning(this.quiz.type
              ? 'Uzupełnij poprawnie wszystkie pola ankiety.'
              : 'Udziel odpowiedzi na wszystkie pytania.'
          );
        }
      }, 10);

      setTimeout(() => {
        if ((this.quiz.type === 0 && !this.isEveryQuestionAnswered)
            || (this.quiz.type === 1 && this.invalidFields.length)) {
          return;
        }

        const parsedAnswers = [];

        Object.entries(this.answers).forEach(([questionId, answerId]) => {
          if (this.quiz.type === SURVEY_QUIZ) {
            if (answerId !== false) {
              parsedAnswers.push({
                question: {
                  id: questionId,
                  answer: {
                    id: answerId,
                  },
                },
              });
            }
          }

          if (this.quiz.type === SURVEY_POLL) {
            const question = this.quiz.questions.find(q => q.id === questionId);

            if (question.type === POLL_QUESTION_TYPE_SELECT
                || question.type === POLL_QUESTION_TYPE_MULTISELECT
            ) {
              parsedAnswers.push({
                question: {
                  id: questionId,
                  answer: {
                    id: answerId,
                  },
                },
              });
            } else if (question.type === POLL_QUESTION_TYPE_TAGS) {
              parsedAnswers.push({
                question: {
                  id: questionId,
                  answer: answerId.map(el => el.value),
                },
              });
            } else {
              parsedAnswers.push({
                question: {
                  id: questionId,
                  answer: answerId,
                },
              });
            }
          }
        });

        this.replaceAnswers = false;
        this.$http.post(`quizzes/${this.quiz.id}`, {
          answers: parsedAnswers
        })
            .then((r) => {
              this.isSolvedModalOpen = true;
              this.message = r.data.result.message;
            })
            .then(() => this.fetchQuiz())
            .then(() => {this.replaceAnswers = true})
            .then(() => this.fetchUser())
      }, 10);
    }, 300),
    getLimits(field) {
      const details = JSON.parse(field.details);

      return details.limits || {};
    },
    countQuizAnswers(newVal) {
      let count = 0;

      Object.entries(newVal).forEach(([, v]) => {
        if (v !== false) {
          count += 1;
        }
      });

      this.answersCount = count;
    },
    countPollAnswers(newVal) {
      let count = 0;

      Object.entries(newVal).forEach(([k, v]) => {
        const field = this.quiz.questions.find(q => q.id === k)

        if (field.type === POLL_QUESTION_TYPE_SWITCH) {
          count += 1;
        } else if (this.hasLength(v)) {
          count += 1;

          //multiselect and number are validated via $refs
          if (field.type !== POLL_QUESTION_TYPE_MULTISELECT && field.type !== POLL_QUESTION_TYPE_NUMBER) {
            this.removeInvalidField(field.id)
          }
        }
      });

      this.answersCount = count;
    },
    hasLength(value) {
      if (value === undefined || value === null || value === false) {
        return false;
      }

      return (typeof v !== 'number' && value.length) || (typeof value === 'number' && toString(value).length)
    },
    pushInvalidField(id) {
      if (!this.invalidFields.includes(id)) {
        this.invalidFields.push(id);
      }
    },
    removeInvalidField(id) {
      const indexOf = this.invalidFields.indexOf(id);

      if (indexOf !== -1) {
        this.invalidFields.splice(indexOf, 1)
      }
    },
    isInvalid(id) {
      return this.invalidFields.indexOf(id) !== -1;
    },
    validateRefs() {
      if (this.quiz.type === SURVEY_QUIZ) {
        return;
      }

      Object.entries(this.$refs).forEach(([, component]) => {
        if (typeof component[0].validate === 'function') {
          component[0].validate();
        }
      });
    },
    validateFields(id = null) {
      Object.entries(this.quiz.questions).forEach(([, question]) => {
        if ((id === null || id === question.id)
            && question.type !== POLL_QUESTION_TYPE_SWITCH
            && question.type !== POLL_QUESTION_TYPE_QUIZ
        ) {
          if (!this.answers.hasOwnProperty(question.id)) {
            this.pushInvalidField(question.id)
          } else if(!this.hasLength(this.answers[question.id])) {
            this.pushInvalidField(question.id)
          }
        }

        if ((id === null || id === question.id) && question.type === POLL_QUESTION_TYPE_QUIZ) {
          if (!this.answers.hasOwnProperty(question.id)) {
            this.pushInvalidField(question.id)
          } else if(!this.answers[question.id]) {
            this.pushInvalidField(question.id)
          }
        }
      })
    },
    validateQuizQuestion(id) {
      if (!this.answers[id]) {
        this.removeInvalidField(id)
      } else {
        this.pushInvalidField(id)
      }
    },
    pushToReturn() {
      let returnPage = this.$route.query.return;
      let name = returnPage.charAt(0).toUpperCase() + returnPage.slice(1) + 'Page';
      let push = { name: name };

      if (this.$route.query.hasOwnProperty('status')) {
        push.query = {
          status: this.$route.query.status,
          showOnPage: this.$route.query.showOnPage,
        }
      }

      this.$router.push(push);
    },
    resolveClassForAnswer(questionId, answer) {
      if (!this.quiz.result || !this.answers[questionId] || answer.is_correct_answer === null) {
        return null;
      }

      const userAnswer = this.answers[questionId];

      if (userAnswer === answer.id) {
        return answer.is_correct_answer ? 'is-correct-answer': 'is-wrong-answer';
      }

      return answer.is_correct_answer ? 'is-correct-answer' : null;
    },
    resolveTextForAnswer(questionId, answer) {
      if (!this.quiz.result || !this.answers[questionId] || answer.is_correct_answer === null) {
        return answer.answer;
      }

      const userAnswer = this.answers[questionId];

      if (userAnswer === answer.id) {
        return answer.answer + " (" + answer.points + " " + this.pointsSymbol + ")";
      }

      return answer.answer;
    }
  },
  computed: {
    ...mapState({
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      }
    }),
    isEveryQuestionAnswered() {
      return this.quiz.questions.length === this.answersCount;
    },
    showReturn() {
      return this.$route.query.hasOwnProperty('return')
    },
  },
  watch: {
    answers: {
      handler(newVal) {
        if (this.quiz.type === SURVEY_QUIZ) {
          this.countQuizAnswers(newVal);
        } else {
          this.countPollAnswers(newVal);
        }
      },
      deep: true,
    },
  }
}
</script>

<style scoped>
.close {
  width: 23px;
  height: 23px;
  margin-top: -15px;
  margin-right: -5px;
}

.subtitle {
  font-weight: 400;
  font-size: 1.2rem;
  color: #3f4047;
}

.has-error {
  color: red;
}

.is-correct-answer {
  color: green;
  font-weight: bold;
}

.is-wrong-answer {
  color: red;
  font-weight: bold;
}
</style>
